import React from 'react';

const testIds = {
    CHEVRON_UP_ICON: 'CHEVRON_UP_ICON'
};

const ChevronUp = (props: any) => (
    <svg
        data-test-id={testIds.CHEVRON_UP_ICON}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.3234 17.8384L12 9.51502L3.67657 17.8384L2 16.1619L12 6.16187L22 16.1619L20.3234 17.8384Z"
            fill="#F9FAFA"
        />
    </svg>
);

export {ChevronUp};
